import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';

import { OnlinePaymentViewComponent } from './components/online-payment-view/online-payment-view.component';

@Injectable()
export class OnlinePaymentService {
  constructor(
    private http: _HttpClient,
    private modalService: NzModalService,
    private injector: Injector
  ) {}

  validatePayment(data: any) {
    const injector = this.injector;
    return new Promise((resolve, reject) => {
      this.http
        .post(`api/onlinepayments/checkPayment?_silent=true`, data)
        .subscribe({
          next: (res: any) => {
            if (res.invalid) {
              injector
                .get(OnlinePaymentService)
                .showConfirmation(res)
                .then(() => {
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            } else {
              resolve(true);
            }
          },
          error: () => {
            reject(false);
          }
        });
    });
  }

  showConfirmation(res: any) {
    const injector = this.injector;
    return new Promise((resolve, reject) => {
      const modal = this.modalService.create({
        nzTitle: 'Confirm Payment?',
        nzCentered: true,
        nzMaskClosable: false,
        nzClosable: false,
        nzContent: OnlinePaymentViewComponent,
        nzWidth: '600px',
        nzFooter: [
          {
            label: 'View Payment History',
            type: 'link',
            loading: false,
            onClick(): void {
              reject(false);
              modal.close();
              modal.destroy();
              injector.get(Router).navigate(['./banking/online-payments']);
            }
          },
          {
            label: 'Continue',
            type: 'primary',
            loading: false,
            onClick(): void {
              resolve(true);
              modal.close();
              modal.destroy();
            }
          },
          {
            label: 'Cancel',
            onClick: () => {
              reject(false);
              modal.close();
              modal.destroy();
            }
          }
        ]
      });

      const instance = modal.getContentComponent();
      instance.message = res.message;
      instance.data = res.payment;
    });
  }
}
